import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

import { LS_ONBOARDING_HOLDOUT_KEY, type OnboardingHoldoutState } from './constants';
import { parseState } from './parseState';

export function getOnboardingHoldoutState(): OnboardingHoldoutState | null {
	try {
		return parseState(AtlBrowserStorageLocal.getItem(LS_ONBOARDING_HOLDOUT_KEY));
	} catch {
		return null;
	}
}
